export class QuoteRequest {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly company: string|null,
    public readonly city: string,
    public readonly street: string,
    public readonly zipcode: string,
    public readonly house_number: string,
    public readonly email: string,
    public readonly phone: string,
    public readonly floor_type: string,
    public readonly area: string,
    public readonly floor_thickness: string|null,
    public readonly subfloor: string|null,
    public readonly message: string|null,
    public readonly handled_at: Date|null,
    public readonly created_at: Date,
    public readonly updated_at: Date,
  ) {
  }

  static fromJson(json: any): QuoteRequest {
    return new QuoteRequest(
      json['id'],
      json['name'],
      json['company'],
      json['city'],
      json['street'],
      json['zipcode'],
      json['house_number'],
      json['email'],
      json['phone'],
      json['floor_type'],
      json['area'],
      json['floor_thickness'],
      json['subfloor'],
      json['message'],
      json['handled_at'] ? new Date(json['handled_at']) : null,
      new Date(json['created_at']),
      new Date(json['updated_at']),

    )
  }
}